(function () {
  function slug(s) {
    return s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
  }
  function siblingsUntilH2(start) {
    var out = [], n = start.nextElementSibling;
    while (n && n.tagName !== 'H2') { out.push(n); n = n.nextElementSibling; }
    return out;
  }
  function init(root) {
    var c = root.querySelector('[data-lpj-content]');
    if (!c || c.getAttribute('data-lpj-ready')) return;
    c.setAttribute('data-lpj-ready', '1');

    var first = c.firstElementChild;
    if (first && first.tagName === 'P' && /^(resposta r[aá]pida|em resumo|resumo)/i.test(first.textContent.trim()) && first.nextElementSibling && /^(UL|OL)$/.test(first.nextElementSibling.tagName)) {
      var sum = document.createElement('div'), lab = document.createElement('p'), lst = first.nextElementSibling;
      sum.className = 'lpj-summary';
      lab.className = 'lpj-summary__label';
      lab.textContent = first.textContent.trim().replace(/:$/, '');
      c.insertBefore(sum, first);
      sum.appendChild(lab);
      sum.appendChild(lst);
      c.removeChild(first);
    }

    Array.prototype.forEach.call(c.querySelectorAll('table'), function (t) {
      if (t.parentNode.classList && t.parentNode.classList.contains('lpj-table')) return;
      var labels = Array.prototype.map.call(t.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
      Array.prototype.forEach.call(t.querySelectorAll('tbody tr'), function (tr) {
        Array.prototype.forEach.call(tr.children, function (td, i) { if (labels[i]) td.setAttribute('data-label', labels[i]); });
      });
      t.removeAttribute('style');
      var w = document.createElement('div');
      w.className = 'lpj-table';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    var side = 0;
    Array.prototype.slice.call(c.querySelectorAll('p')).forEach(function (p) {
      var img = p.querySelector('img');
      if (!img || p.textContent.trim() !== '') return;
      var f = document.createElement('figure');
      f.className = 'lpj-figure ' + (side++ % 2 ? 'lpj-figure--r' : 'lpj-figure--l');
      img.removeAttribute('style');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      f.appendChild(img);
      p.parentNode.replaceChild(f, p);
    });

    var h2s = Array.prototype.slice.call(c.querySelectorAll('h2'));
    h2s.forEach(function (h) {
      var t = h.textContent.trim();
      if (/^checklist/i.test(t)) {
        var els = siblingsUntilH2(h), wrap = document.createElement('div'), card = null;
        wrap.className = 'lpj-cards';
        els.forEach(function (el) {
          if (el.tagName === 'H3') { card = document.createElement('div'); card.className = 'lpj-card'; wrap.appendChild(card); }
          (card || wrap).appendChild(el);
        });
        h.parentNode.insertBefore(wrap, h.nextSibling);
      } else if (/^perguntas frequentes/i.test(t)) {
        var items = siblingsUntilH2(h), faq = document.createElement('div'), ans = null;
        faq.className = 'lpj-faq';
        items.forEach(function (el) {
          if (el.tagName === 'H3') {
            var d = document.createElement('details'), s = document.createElement('summary');
            s.textContent = el.textContent.trim();
            d.appendChild(s);
            ans = document.createElement('div');
            ans.className = 'lpj-faq__a';
            d.appendChild(ans);
            faq.appendChild(d);
            el.parentNode.removeChild(el);
          } else if (ans) { ans.appendChild(el); } else { faq.appendChild(el); }
        });
        h.parentNode.insertBefore(faq, h.nextSibling);
      }
    });

    var toc = root.querySelector('.lpj-toc__list');
    if (toc && h2s.length) {
      h2s.forEach(function (h, i) {
        if (!h.id) h.id = slug(h.textContent) || ('secao-' + (i + 1));
        var li = document.createElement('li'), a = document.createElement('a'), n = document.createElement('span');
        a.href = '#' + h.id;
        n.textContent = (i < 9 ? '0' : '') + (i + 1);
        a.appendChild(n);
        a.appendChild(document.createTextNode(h.textContent.trim()));
        li.appendChild(a);
        toc.appendChild(li);
      });
      var box = root.querySelector('.lpj-toc__box');
      if (box && window.matchMedia('(max-width: 1099px)').matches) box.removeAttribute('open');
      var links = toc.querySelectorAll('a');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            Array.prototype.forEach.call(links, function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
          });
        }, { rootMargin: '0px 0px -70% 0px' });
        h2s.forEach(function (h) { io.observe(h); });
      }
    } else if (toc) {
      var nav = root.querySelector('.lpj-toc');
      if (nav) nav.parentNode.removeChild(nav);
    }

    var bar = root.querySelector('.lpj-progress span');
    if (bar) {
      var ticking = false;
      var update = function () {
        var r = c.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        bar.style.setProperty('--p', p);
        ticking = false;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  }
  function run() { Array.prototype.forEach.call(document.querySelectorAll('.lpj'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
